// extracted by mini-css-extract-plugin
module.exports = {"container":"PaginationControl_container__15eGt","pages":"PaginationControl_pages__gBYXJ"};